<template>
    <div class="c-cesium-basemap" ref="container">
        <Render :render="renderMap"/>
    </div>
</template>

<script>
import { LRouteMap } from '@OpenLayersCommon';
import { CMap, MapManager } from '@CesiumCommon';
import { Render } from '@CommonComponent';

export default {
    // LRouteMap, Render
    components: { Render },
    props: {
        airlineConfig: Object,
        renderMap: Function,
        searchHive: Object,
        SeeShow: Boolean,
    },
    data() {
        return {
            show: false,
            index: 0,
        };
    },
    watch: {},
    mounted() {
    },
    methods: {
        binshow() {
            this.$props.showLeft();
            // this.show = true;
        },
        closeLeft() {
            this.show = false;
        },
        selectFile() {
            let el = this.$refs.fileselect;
            el.click();
        },
        alertErr() {
            this.$message.error(this.$t('taskPage.taskMap.onlyKmlFile'));
        },

        updatePoints() {
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.c-cesium-basemap {
    // width: 100vw;
    // height: 100vh;
    .map {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: white; //rgba(3, 5, 63, 0.7);

    }
}
</style>
